module.exports = __webpack_public_path__ + "src/img/box.c75a2807.svg";